<template>
    <!-- 对话框 -->
    <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px" :wrapperClosable='false'>

        <!-- 基本信息表单 -->
        <div class="form-box">


            <template>

                <el-form ref="form" :model="submit_data" label-width="80px" class="form-wrap">

                    <el-form-item label="司机名称:" label-width='120px'>
                        <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder"
                                  style="width: 80%;">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="手机号码:" label-width='120px'>
                        <el-input v-model="submit_data.phone" :placeholder="submit_rules.phone.placeholder"
                                  maxlength='11'
                                  style="width: 80%;">
                        </el-input>
                    </el-form-item>


                    <el-form-item label="备注:" label-width='120px'>
                        <el-input v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder"
                                  style="width: 80%;">
                        </el-input>
                    </el-form-item>


                </el-form>


                <!-- 对话框底部按钮 -->
                <div style="display: flex;justify-content: center">
                    <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules"
                               :url="submit_url" :JSON_Boolean="false"></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>

            </template>


        </div>


    </el-drawer>
</template>

<script>

    var _this;
    export default {
        props: {
            'isShow': Boolean
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

            }
        },
        data() {
            return {


                show: false,
                form: {
                    data: ''
                },

                submit_url: '/driver/addDriverSubmit',
                // 表单数据
                submit_data: {
                    name: '',
                    phone: '',
                    remarks: '',
                    reg_from: 'pc'
                },

                submit_rules: {
                    name: {
                        placeholder: '司机名称需在8字之内',
                        rules: {
                            required: false,
                            message: '司机名称需在8字之内',
                            regulation: 'elt_str',
                            rulesData: 8
                        }
                    },
                    phone: {
                        placeholder: '手机号码必须为11位',
                        rules: {
                            required: false,
                            message: '手机号码必须为11位',
                            regulation: 'eq_str',
                            rulesData: 11
                        }
                    },
                    remarks: {
                        placeholder: '备注，200字节之内',
                        rules: {
                            required: false,
                            message: '备注，200字节之内',
                            regulation: 'elt_str',
                            rulesData: 200
                        }
                    }
                }

            };
        },
        created() {

            _this = this;

        },
        methods: {


            // 关闭方法
            closeDialog() {
                _this.show = false;
                for (const key in _this.submit_data) {
                    _this.submit_data[key] = '';
                }
                _this.submit_data.reg_from = 'pc';
            },


            // 提交
            onSubmitDig() {
                console.log(_this.submit_data.phone.length);
                // 触发父组件自定义事件刷新表格
                _this.$emit('onSubmit');
                _this.closeDialog();

            }


        }
    };
</script>

<style scoped>
.form-wrap{
    height: calc(100vh - 100px);
    overflow-y: auto;
    margin-top: 20px;
  }
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
</style>